// extracted by mini-css-extract-plugin
export default {"container":"VpIKOeC2IsveYsHvsLvV","link":"Q2UMLo_4TlIkxUuuaFaz"};